import React, {useEffect, useState} from 'react';
import {useMsal, useIsAuthenticated} from '@azure/msal-react';
import {
  InteractionStatus,
  InteractionRequiredAuthError,
} from '@azure/msal-browser';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {sagaActions} from './redux/saga';

const AzureSignIn = () => {
  const {instance, accounts, inProgress} = useMsal();
  const loading = useSelector((state) => state.auth.loading);
  const token = useSelector((state) => state.auth.token);
  const isAuthenticated = useIsAuthenticated();
  const history = useHistory();
  const dispatch = useDispatch();
  const [isFetchedToken, setIsFetchedToken] = useState(false);

  const loadUser = (b2cToken) => {
    if (!loading) {
      dispatch({
        type: sagaActions.LOAD_USER,
        payload: {token: b2cToken, history},
      });
    }
  };

  useEffect(() => {
    if (
      !loading &&
      inProgress === InteractionStatus.None &&
      accounts.length > 0 &&
      !isFetchedToken
    ) {
      if (token) {
        // Skip data refresh if already set - adjust logic for your specific use case
        return;
      }

      const tokenRequest = {
        account: accounts[0],
        scopes: [
          'openid',
          'offline_access',
          'ae717117-b5d3-4739-9214-d3bdaba7320c',
        ],
      };

      // Acquire an access token
      instance
        .acquireTokenSilent(tokenRequest)
        .then((response) => {
          console.log('call api to get details of login account', response);
          setIsFetchedToken(true);
          loadUser(response.accessToken);
        })
        .catch(async (e) => {
          // Catch interaction_required errors and call interactive method to resolve
          if (e instanceof InteractionRequiredAuthError) {
            await instance.acquireTokenRedirect(tokenRequest);
          }

          throw e;
        });
    }
  }, [inProgress, accounts, instance, loading, token, isAuthenticated]);

  const handleLoginWithAD = () => {
    const loginRequest = {
      scopes: [
        'openid',
        'offline_access',
        'ae717117-b5d3-4739-9214-d3bdaba7320c',
      ],
      // scopes: ['profile', 'mail.read'],
    };
    instance.loginRedirect(loginRequest);
  };

  useEffect(() => {
    if (!loading && inProgress === InteractionStatus.None && !isAuthenticated) {
      handleLoginWithAD();
    }
  }, [isAuthenticated, inProgress]);

  return <div>Please wait...</div>;
};

export default AzureSignIn;
